
export const oAuthSecret = 'a7b2844e766e3cd5b751cf3ce1e45a99';
export const canvasKey = 'canvas-ahs';
export const userApiUrl = 'https://lib.arteveldehogeschool.be/mediatheken/dev/user/api.php';


export const API_KEY = "qwertyuiopasdfghjklzxcvbnm";
export const API_BASE_URL = "https://lib.arteveldehogeschool.be/mediatheken/api/v1/";